import { useState, useEffect } from 'react';
import { IconDeviceFloppy, IconLock } from '@tabler/icons-react';
import { fetchShippingZones, saveShippingZones } from '../lib/storeData';
import { showToast } from '../components/ui/Toast';

export default function AdminShipping() {
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);
  const [saved, setSaved] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchShippingZones().then(res => {
      if (cancelled) return;
      setZones(res.zones);
      setLoadError(res.error);
      setLoading(false);
    });
    return () => { cancelled = true; };
  }, []);

  function updateZone(index, field, value) {
    setZones(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
    setSaved(false);
  }

  async function save() {
    if (saving) return;
    if (loadError) {
      showToast('Not connected to the database. Changes were not saved.', 'error');
      return;
    }
    setSaving(true);
    const result = await saveShippingZones(zones);
    setSaving(false);
    if (result.error) {
      showToast(result.error, 'error');
      return;
    }
    setSaved(true);
    showToast('Shipping rates saved');
  }

  if (loading) {
    return <p className="adm-sub">Loading shipping zones...</p>;
  }

  return (
    <div>
      <h1 className="adm-title">Shipping zones and rates</h1>
      <p className="adm-sub">These rates appear on the policies page and at checkout. Zone names are fixed so checkout always matches countries correctly.</p>

      <div className="adm-card" style={{ padding: 0, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ background: 'rgba(74,46,26,0.04)', fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.1em', color: '#888' }}>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500 }}>Zone</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500 }}>Countries</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500 }}>Standard ($)</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500 }}>Express ($)</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500 }}>Standard estimate</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500 }}>Express estimate</th>
            </tr>
          </thead>
          <tbody>
            {zones.map((z, i) => (
              <tr key={z.id} style={{ borderBottom: '1px solid rgba(74,46,26,0.08)' }}>
                <td style={{ padding: '8px 14px', fontWeight: 500, whiteSpace: 'nowrap' }}>
                  <IconLock size={11} color="#aaa" style={{ marginRight: 5, verticalAlign: -1 }} />{z.name}
                </td>
                <td style={{ padding: '8px 14px' }}><input className="adm-input" value={z.countries} onChange={e => updateZone(i, 'countries', e.target.value)} style={{ fontSize: 12 }} /></td>
                <td style={{ padding: '8px 14px' }}><input className="adm-input" type="number" min="0" value={z.standard_rate} onChange={e => updateZone(i, 'standard_rate', e.target.value)} style={{ fontSize: 12, width: 70 }} /></td>
                <td style={{ padding: '8px 14px' }}><input className="adm-input" type="number" min="0" value={z.express_rate} onChange={e => updateZone(i, 'express_rate', e.target.value)} style={{ fontSize: 12, width: 70 }} /></td>
                <td style={{ padding: '8px 14px' }}><input className="adm-input" value={z.standard_estimate} onChange={e => updateZone(i, 'standard_estimate', e.target.value)} style={{ fontSize: 12 }} /></td>
                <td style={{ padding: '8px 14px' }}><input className="adm-input" value={z.express_estimate} onChange={e => updateZone(i, 'express_estimate', e.target.value)} style={{ fontSize: 12 }} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="adm-save-bar">
        <span className={'adm-save-status' + (saved ? ' adm-save-status--saved' : '')}>
          {saved ? '\u2713 Saved' : '\u25cf Unsaved'}
        </span>
        <button className="adm-btn" disabled={saving} onClick={save} style={{ opacity: saving ? 0.6 : 1 }}>
          <IconDeviceFloppy size={14} /> {saving ? 'Saving...' : 'Save'}
        </button>
      </div>
    </div>
  );
}